import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_68: FaireProductEntity = {
  token: "starter_collection_68",
  type: "product",
  name: "Les Trois Napkin Holder",
  brandName: "Atelier Saucier",
  imageUrl: "",
  priceDollars: 45,
  msrpDollars: 90,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
